<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Reporting</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <!--Tab des Prospects et Tab des Souscriptions-->
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                    
                        </div>
                        <div class="card-body">
                            <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Prospects</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Souscriptions</a>
                                    </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!---->
            <section id="basic-tabs-components">
                <div class="row match-height">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Prospects</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Souscriptions</a>
                                    </li> -->
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="home" aria-labelledby="home-tab" role="tabpanel">
                                        <all-prospect/>
                                    </div>
                                    <div class="tab-pane" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                                        <!-- <all-subscription ref="all" :content="subscriptions"/> -->
                                        <!-- <negotiated-prospect :content="subscriptions" :content2="saveSubscriptions"/> -->
                                        <negotiated-prospect />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import allProspect from './item/all.vue'
    import negotiatedProspect from './item/negotiated.vue'



    export default {
        name: "list",
        components: { allProspect, negotiatedProspect },
        props:['all','save'],
        data: () => ({
            
        }),
        created() {
            
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>
